// extracted by mini-css-extract-plugin
export default {"loadingContainer":"OAuthSuccess_loadingContainer__i2lG6","spinner":"OAuthSuccess_spinner__c4XQI","spin":"OAuthSuccess_spin__nHRrM"};